import React from 'react';
const tomos = [{
  icon: '🟢',
  name: 'Tomo 1 — Sub-10',
  desc: '48 sem · Roja/Naranja · Fundamentos'
}, {
  icon: '🟡',
  name: 'Tomo 2 — Junior',
  desc: '48 sem · G3/G4 · Técnica y competencia'
}, {
  icon: '🟠',
  name: 'Tomo 3 — Adultos',
  desc: '48 sem · 3ra a 5ta · Retención y grupos'
}, {
  icon: '🔴',
  name: 'Tomo 4 — Avanzado',
  desc: '48 sem · 1ra/2da · Alto rendimiento'
}, {
  icon: '🟣',
  name: 'Tomo 5 — Táctica',
  desc: 'Patrones, superficies y lectura del rival'
}, {
  icon: '⭐',
  name: 'Tomo 6 — Físico y Mental',
  desc: 'Físico en cancha, nutrición y psicología'
}];
const incluye = ['Planificación anual completa', 'Sistema "Abrir y Dictar"', 'Fichas de evaluación por alumno', 'Adaptado a categorías AAT'];
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-12 px-4" data-id="element-289">
      <div className="max-w-5xl mx-auto" data-id="element-290">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-291">
          Lo que <span className="text-[#00B4D8]" data-id="element-292">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-10" data-id="element-293">
          <div className="bg-black border border-[#00B4D8]/30 rounded-2xl p-5" data-id="element-294">
            <h3 className="text-[#00B4D8] text-lg font-black mb-4" data-id="element-295">
              🎾 LOS 6 TOMOS
            </h3>
            <div className="space-y-3" data-id="element-296">
              {tomos.map(t => <div key={t.name} className="flex items-center gap-3 text-white" data-id="element-297">
                  <span className="text-lg flex-shrink-0" data-id="element-298">{t.icon}</span>
                  <div className="flex-1 text-sm" data-id="element-299">
                    <span className="font-bold" data-id="element-300">{t.name}</span>
                    <span className="text-gray-400" data-id="element-301"> · {t.desc}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <div className="max-w-2xl mx-auto text-center" data-id="element-302">
          <p className="text-gray-400 text-sm mb-3" data-id="element-303">Cada tomo incluye:</p>
          <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-304">
            {incluye.map(item => <span key={item} className="bg-[#00B4D8]/10 border border-[#00B4D8]/30 text-[#00B4D8] text-xs sm:text-sm font-semibold px-3 py-1.5 rounded-full" data-id="element-305">
                ✅ {item}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}